import React  from 'react';
import { Button, DialogActions } from '@material-ui/core';
import { useMutation } from 'react-query';
import { updateObjectiveKPI } from '../../../api/objective/objectiveKPI.api';
import ObjectiveKPIForm from './ObjectiveKPIForm';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const UpdateKPI = ({
  kpi,
  objective,
  onSubmitSuccess,
  onCancel
}) => {
  const { t } = useTranslation();
  const form = useForm({ defaultValues: kpi });

  const updateMutation = useMutation(
    async values => {
      await updateObjectiveKPI({
        kpi: {
          ...kpi,
          objectiveId: objective.id,
          ...values
        },
        objectiveId: objective.id,
        ownerId: objective.owner[0].id,
        ownerType: objective.owner[0].type
      });
    },
    {
      onSuccess: () => {
        onSubmitSuccess?.();
      }
    }
  );

  return <FormProvider { ...form }>
    <form onSubmit={ form.handleSubmit(updateMutation.mutate) }>
      <ObjectiveKPIForm />
      <DialogActions style={ { marginTop: 8 } }>
        <Button type='submit' color='primary' variant='contained'>
          { t('objective.dialog.save') }
        </Button>
        <Button onClick={ onCancel } color='primary'>
          { t('objective.dialog.cancel') }
        </Button>
      </DialogActions>
    </form>
  </FormProvider>;
};

export default UpdateKPI;
